import { fetcher } from "@website/fetcher/fetcher/fetcher";
import {
  removeCookie,
  setCookie
} from "@website/fetcher/refresh-token/cookie-util";
import {
  AuthResponse,
  RefreshTokenResponse
} from "@website/fetcher/refresh-token/types";
import { authStore } from "@website/store/store";
import { setTracking } from "@website/store/tracking";
import { isChannel } from "@website/utils/channel/helpers";
import { uuid } from "@website/utils/uuid";

const baseURLProfile = `${
  process.env.NEXT_PUBLIC_BASE_URL_PLATFORM ||
  "https://platform-api.asiatech.ptp"
}/profile`;

const logout = () => {
  authStore.accessToken.delete();
  authStore.refreshToken.delete();
  authStore.jekToken.delete();
  authStore.delete();
  localStorage.removeItem("auth_store");
  localStorage.removeItem("access-token");
  localStorage.removeItem("refresh-token");
  removeCookie("access-token", {});
  removeCookie("refresh-token", {});
  setTracking((previous) => ({ ...previous, sid: uuid() }));
};

const saveLogin = (data: Partial<AuthResponse>) => {
  if (data?.accessToken) {
    authStore.accessToken.set(data?.accessToken);
    localStorage.setItem("access-token", data?.accessToken);
    setCookie("access-token", data?.accessToken, {});
  }
  if (data?.refreshToken) {
    authStore.refreshToken.set(data?.refreshToken);
    localStorage.setItem("refresh-token", data?.refreshToken);
    setCookie("refresh-token", data?.refreshToken, {});
  }
};

export const refreshToken = () =>
  fetcher<RefreshTokenResponse>({
    url: `${baseURLProfile}/auth/refresh-token`,
    method: "POST",
    data: { refreshToken: authStore.refreshToken.get() }
  })
    .then(({ data }) => {
      saveLogin(data);
    })
    .catch((error) => {
      logout();
      throw error;
    });

export const forceLogin = async (forceLoginParameter: unknown) => {
  if (isChannel(["b2b"])) {
    if (typeof window !== "undefined") window.location.href = "/b2b-login";
  } else {
    const isFlight = Boolean(process.env.NEXT_PUBLIC_APP_NAME_TICKET);

    const forceLoginModule = await (isFlight
      ? import("@website/utils/force-login-v2")
      : import("@website/utils/force-login"));
    return forceLoginModule.forceLogin(forceLoginParameter);
  }
};
